import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Card } from "reactstrap";
import { Link } from "react-router-dom";
import profileImg from "../../assets/images/profile-img.png";
import Nouserimage from "../../assets/images/users/no_image.png";
import UserService from "Api/Services/UserService";
import Spinners from "components/Common/Spinner";

const WelcomeComp = ({ doctorId = "" }) => {
  const [userData, setUserData] = useState({
    name: 'Loading...',
    username: 'Loading...',
    profileImage: Nouserimage,
    practicename: 'Loading...',
    qualification: 'Loading...',
    specialty: 'Loading...'
  });
  const [isLoading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadUserData = async () => {
      try {
        const response = await UserService.GetUser(doctorId || null);

        if (response?.status === false) {
          setError(response.message);
          return;
        }

        setUserData({
          name: response.data.name || '-',
          practicename: response.data.practicename || '-',
          username: response.data.username || 'User',
          specialty: response.data.specialty || '-',
          qualification: response.data.qualification || '-',
          profileImage: response.data.profile_image
            ? `${process.env.REACT_APP_PROFILE_IMAGE_API_URL}/${response.data.profile_image}`
            : Nouserimage
        });
      } catch (error) {
        setError('Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    loadUserData();
  }, [doctorId]);

  if (error) {
    return (
      <Card className="border-0 shadow-none overflow-hidden">
        <div className="p-4 text-danger">
          {error}
        </div>
      </Card>
    );
  }

  return (
    <Card className="border-0 shadow-none overflow-hidden">
      {/* Blue Section */}
      <div className="bg-primary-subtle p-4 rounded-top position-relative">
        <Row className="align-items-center">
          <Col xs="8">
            <h4 className="text-primary mb-2">Welcome {userData.username}!</h4>
            <p className="text-muted mb-0">{userData.practicename}</p>
          </Col>
          <Col xs="4" className="text-end">
            <img
              src={profileImg}
              alt=""
              className="img-fluid"
              style={{ width: "80px", opacity: "0.7" }}
              loading="lazy"
            />
          </Col>
        </Row>
      </div>

      {/* White Section */}
      <div className="bg-white w-100 p-3">
        <Row className="align-items-center">
          <Col xs="auto">
            <img
              src={userData.profileImage}
              alt=""
              className="rounded-circle"
              style={{ width: '50px', height: '50px' }}
              loading="lazy"
            />
          </Col>
          <Col>
            <h6 className="mb-1">{userData.name}</h6> 
            <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
              {userData.specialty}
            </p>
            <p className="text-muted mb-0" style={{ fontSize: '12px' }}>
              {userData.qualification}
            </p>
          </Col>
          <Col xs="auto">
            <Link
              to="/user-profile"
              className="btn btn-primary btn-sm"
              style={{ fontSize: '12px' }}
            >
              View Profile <i className="mdi mdi-arrow-right ms-1"></i>
            </Link>
          </Col>
        </Row>
      </div>
      {isLoading && (
        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center bg-white bg-opacity-75">
          <Spinners setLoading={setLoading} />
        </div>
      )}
    </Card>
  );
};

export default React.memo(WelcomeComp);

WelcomeComp.propTypes = {
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
